<template>
  <pt-reward-grant-form class="pt-reward-grant-form__page"></pt-reward-grant-form>
</template>

<script>
import PtRewardGrantForm from 'cps/new-to-old-audit/pt-manual-reward/pt-reward-grant-form'
export default {
  name: 'pt-reward-grant-form__view',
  components: {
    'pt-reward-grant-form': PtRewardGrantForm
  }
}
</script>
